"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var react_1 = __importDefault(require("react"));
function mapSize(size) {
    if (size === void 0) { size = "lg"; }
    switch (size) {
        case "xs":
            return "text-base font-bold";
        case "sm":
            return "text-lg";
        case "md":
            return "text-xl";
        case "lg":
            return "text-2xl";
    }
}
function getColor(dark) {
    return dark ? "text-white font-thin" : "text-teal-darker font-normal";
}
var Header = function (_a) {
    var children = _a.children, size = _a.size, dark = _a.dark, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (react_1.default.createElement("h1", { className: "".concat(mapSize(size), " mb-2 ").concat(getColor(dark), " ").concat(className) }, children));
};
exports.Header = Header;
